export type LayoutNormalizationSurface = 'passive-load' | 'paper-resnap'

export type LayoutNormalizationPolicy = {
  alignColumns: boolean
  overlapMode: 'none' | 'soft'
}

export const resolveLayoutNormalizationPolicy = (
  surface: LayoutNormalizationSurface
): LayoutNormalizationPolicy => {
  if (surface === 'paper-resnap') {
    return {
      alignColumns: true,
      overlapMode: 'soft'
    }
  }

  return {
    alignColumns: true,
    overlapMode: 'none'
  }
}
